import styled from "styled-components";

// PAGE STYLE
export const PublicPageStyle = styled.div`
    width: 100vw;
    height: 100vh;
    aspect-ratio: 16 / 9 !important;

    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    /* padding: 1%; */

    @media screen and (max-width: 1500px) {
        width: 1920px !important;
        height: 1080px !important;
        aspect-ratio: 16 / 9 !important;
        span,
        div,
        td,
        tr,
        th {
            font-size: 1rem !important;
        }
    }
`;

// CARD STYLE
export const PublicCardStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 1%;
    box-sizing: border-box;
`;
